// Adding all the comonly used string manipulation functions here
import { NAVIGABLE_PATHS } from '../../../core/constants';
import { ExcludeParamKeys } from '../constants';

export const hasValue = (str: string) => (
  str !== null && str !== undefined && str.length > 0
);

// Params ride in a path segment, and the hosts disagree on how many times they decode
// it - local once, deployed twice - so no percent-encoding depth is safe for free text.
// base64url is: its alphabet is untouched by decoding. See BREN-881.
export const SEARCH_PARAM = 'searchB64';

export const toBase64Url = (value: unknown): string => {
  const utf8 = encodeURIComponent(String(value))
    .replace(/%([0-9A-F]{2})/g, (_match, hex) => String.fromCharCode(parseInt(hex, 16)));

  return btoa(utf8)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
};

// Only `search` is free text. Filter values stay percent-encoded so their decoded form
// keeps matching the route params the backend caching job hashes into its Redis keys.
export const buildSearchParams = (params: object): string => {
  let searchParams = '';

  for (const [key, value] of Object.entries(params)) {
    if (!value || ExcludeParamKeys.includes(key)) {
      continue;
    }

    if (key === 'search') {
      searchParams += `${SEARCH_PARAM}=${toBase64Url(value)}&`;
      continue;
    }

    if (Array.isArray(value)) {
      for (const el of value) {
        searchParams += `${key}=${encodeURIComponent(String(el))}&`;
      }
      continue;
    }

    searchParams += `${key}=${encodeURIComponent(String(value))}&`;
  }

  return searchParams.replace(/.$/g, '');
};

export const isValidString = (value: any) =>
  typeof value === 'string' && value.trim().length > 0;

export const isValidArray = (value: any) =>
  Array.isArray(value) && value.length > 0;

export const formatNumberUS = (value?: number, options?: Intl.NumberFormatOptions) => {
  if (value === null || value === undefined) {
    return 'N/A';
  }

  return new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 0,
    ...options
  }).format(value);
};

export const ENDPOINT_TO_TAB_NAME: Record<string, string> = Object.fromEntries(
  Object.entries(NAVIGABLE_PATHS).map(([tabName, endpoint]) => [endpoint, tabName])
);

